'use strict';
import axios from 'axios';
import getHeader from '../config/header';
import Addresses from './addresses.controller';

const API_URL = process.env.VUE_APP_API_URL || "http://localhost:3001/api";

const Museums = {

    async getAll() {
		try {
            let response = await axios.get(API_URL + '/museums');

			return response.data;

		} catch(error) {
            return false;
		}
	},

	async getTotalCount() {
		try {
			const header = await getHeader();
            let response = await axios.get(API_URL + '/museums', header);

			return response.data.length;

		} catch(error) {
            return false;
		}
	},

	async createNew(name, address1, address2, city, state, postalCode, country, description = null) {
		try {
			if (!name || !address1 || !city || !postalCode || !country) {
				return { error: 'At least one field is missing.' };
			}

			let addressID = await Addresses.createNew(address1, city, state, postalCode, country, address2);
			if (addressID.error) {
				return { error: addressID.error };
			} else if (addressID == false) {
				return { error: 'Error creating your address' };
			}

			const header = await getHeader();
			let response = await axios.post(API_URL + '/museum', {
				"name": name,
				"addressId": addressID,
				"description": description == "" ? null : description
			}, header);

			return !response.data.id ? false : response.data;

		} catch(error) {
			return false;
		}
	},

	async getCuratorMuseums(curatorUID) {
		try {
			const header = await getHeader();
			let response = await axios.get(API_URL + '/user/' + curatorUID, header);

			return response.data.museums;

		} catch(error) {
            return false;
		}
	},

	async update(museumID, name, addressID, description = null) {
		try {
			if (!museumID || !name || !addressID) {
				return { error: 'A mandatory field is missing' };
			}

			const header = await getHeader();
			let response = await axios.patch(API_URL + '/museum/' + museumID, {
				"id": museumID,
				"name": name,
				"addressId": addressID,
				"description": description == "" ? null : description
			}, header);
		
			if (response.data) {
				return true;
			}

		} catch(error) {
			return false;
		}
	},

	async uploadImage(museumID, filename, content) {
		try {

			if (!museumID || !filename || !content) {
				return { error: 'A mandatory field is missing' };
			}

			const header = await getHeader();

			let response = await axios.post(API_URL + '/museum/upload/' + museumID, {
				"fileName": filename,
				"content": content
			}, header);

			return !response.data.image ? false : response.data;
		
		} catch(error) {
            return false;
		}
	},

	async approve(museumID) {
		try {
			if (!museumID) {
				return { error: 'A mandatory field is missing' };
			}

			const header = await getHeader();

			let response = await axios.post(API_URL + '/museum/approve/' + museumID, {
				"approved": true
			}, header);

			return !response.data.id ? false : true;
		
		} catch(error) {
            return false;
		}
	},

	async delete(museumID) {
		try {
			if (!museumID) {
				return { error: 'The MuseumID is missing.' };
			}

			const header = await getHeader();
			let response = await axios.delete(API_URL + '/museum/' + museumID, header);

			return response.data.message.includes("Successfully deleted the museum");
		
		} catch(error) {
			return false;
		}
	},

	async requestToBeListed(userInfo, museumInfo) {
		try {
			if (!userInfo.name || !userInfo.phone || !userInfo.email) {
				return { error: "Please fill in all your personal information" };
			}

			if (!museumInfo.name || !museumInfo.address || !museumInfo.city || !museumInfo.state || !museumInfo.postalCode || !museumInfo.country) {
				return { error: "Please fill in all of your institute's information" };
			}

			let header = {};
			try {
				// Try to get auth header if user is logged in
				const authHeader = await getHeader();
				header = authHeader;
			} catch (authError) {
				// If not authenticated, send request without auth header
				// This is for public museum request from sign-up page
				header = {};
			}

			let response = await axios.post(API_URL + '/museum/request', {
				"name": userInfo.name,
				"email": userInfo.email,
				"phoneNumber": userInfo.phone,
				"museumName": museumInfo.name,
				"address": museumInfo.address,
				"city": museumInfo.city,
				"state": museumInfo.state,
				"postalCode": museumInfo.postalCode,
				"country": museumInfo.country
			}, header);

			return response.data.message.includes("Email sent successfully");

		} catch(error) {
			console.error("Error in requestToBeListed:", error);
			return false;
		}
	}
    
}

export default Museums;